export enum CalendarMonths {
  "January" = 0,
  "February" = 1,
  "March" = 2,
  "April" = 3,
  "May" = 4,
  "June" = 5,
  "July" = 6,
  "August" = 7,
  "September" = 8,
  "October" = 9,
  "November" = 10,
  "December" = 11
}

export enum CalendarMonthsAbbrev {
  "Jan" = 0,
  "Feb" = 1,
  "Mar" = 2,
  "Apr" = 3,
  "May" = 4,
  "Jun" = 5,
  "Jul" = 6,
  "Aug" = 7,
  "Sep" = 8,
  "Oct" = 9,
  "Nov" = 10,
  "Dec" = 11
}
